module.exports = {
      id: "trending-usage",
      viewBox: "0 0 27.001 27.001",
      url: "/" + "sprite-a5f842c290447276eba09a9bdedabd59.svg#trending",
      toString: function () {
        return this.url;
      }
    }